import './scripts/common';
import './scripts/common-nav';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as interactiveMap from './scripts/interactive-map';
interactiveMap.init();

import * as filterDropdown from './scripts/filterDropdown';
filterDropdown.init();

import * as overlayToggle from './scripts/overlay-toggle';
overlayToggle.init({onlyMobile: false});

import * as ajaxFormSubmit from './scripts/ajax-form-submit';
ajaxFormSubmit.init();